<template>
  <div class="molecule text" :style="'text-align:' + text.align">
    <AtomsCollectionButton
      v-if="text.collection"
      :collection="text.collection"
    />
    <h2
      v-if="text.title1"
      class="text-3xl font-semibold md:text-5xl title-1 font-archer"
      :style="'color:' + text.title1color"
    >
      {{ text.title1 }}
    </h2>
    <h3
      v-if="text.title2"
      class="text-5xl font-semibold title-2 font-archer"
      :style="'color:' + text.title2color"
    >
      {{ text.title2 }}
    </h3>
    <h4
      v-if="text.title3"
      class="text-xl title-3 font-arial"
      :style="'color:' + text.title3color"
    >
      {{ text.title3 }}
    </h4>
    <div
      v-if="text.description"
      v-html="text.description"
      class="description"
      :style="'color:' + text.descriptionColor"
    ></div>
    <MoleculesButtons
      :buttons="text"
      :button-colors="
        text.buttonColors && Array.isArray(text.buttonColors)
          ? text.buttonColors
          : []
      "
    />
  </div>
</template>

<style>
.text {
  .description {
    @apply pb-8 sm:pb-0;
    a {
      @apply underline text-bc-blue;
    }

    p {
      @apply pb-4;
    }
  }
}
</style>

<script setup>
const props = defineProps({
  text: Object,
});
</script>
